import styled, { css } from 'styled-components';
import { T } from '@/ui/Text/Text';
import { Flex } from '@/ui/Flex/Flex';
import { Button } from '@/ui/Button/Button';
import { theme } from '@/theme';

export const StyledButton = styled(Button)`
  width: 100%;
`;
export const StyleCheckbox = styled.div`
  display: flex;
  gap: 10px;
`;

export const StyledNFCMappingViewCnt = styled(Flex)`
  gap: 16px;
  height: 61.5vh;
  overflow: auto;
`;

export const StyledControllersWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const StyledTagRow = styled(Flex)`
  display: flex;
  gap: 8px;

  .tag-id {
    flex: 1;
  }

  .tag-channel {
    max-width: 64px;
  }
`;

export const StyledSettingRow = styled.div<{ readonly enabled: boolean }>`
  position: relative;
  display: flex;
  align-items:center;
  cursor:pointer;
  width: 100%;
  gap: 16px;
  justify-content: space-between;

  .select{
    flex: 1;
  }

  .switch {
    ${({ enabled }) =>
      enabled &&
      css`
        .react-switch-bg {
          background: ${() => theme.color('#158AD6')} !important;
        `}
    }

    .react-switch-handle{
      width:22px !important;
      height:22px !important;
      top: 3px !important;
      left: 2px;
    }
  }
`;

export const StyledFormattedMessageCnt = styled(T)`
  text-align: center;
`;

export const StyledSettingTitle = styled.h2`
  user-select: none;
  font-size: 1rem;
  margin: 16px;
  margin-left: 0;
  font-weight: 100;
`;

export const selectorStyle = {
  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    color: theme.color('#1B1A1F'),
    ':hover': {
      color: theme.color('#1B1A1F'),
    },
    rotate: state.selectProps.menuIsOpen ? '180deg' : undefined,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  option: (styles: any) => ({
    ...styles,
    display: 'flex',
    alignItems: 'center',
  }),
};
